export const passCodes = [
    '^(vam|u)p[i|í]r$', // 3
    '^(e|e!)$', // 9
    '^b$', // 11
    '^(3|c)$', // 15
    '^(3|c)$', // 16
    '^(2|b)$', // 17
    '^(3|c)$', // 18
    '^(1|a)$', // 19
    '^14$', // 22
    '^(na)?h[r|ř]bitov([e|ě]?)$', // 26
    '^((kl[ií][cč]ov[áa] d[ií]rk?a)|(d[ií]rk?a( na kl[ií]c)?)|z[aá]mek)$', //27
    '^6$', //28
    '^5$', //29
];

export const commonMistakeCodes = [
    // '^orel$', // 5
];
